import { Pipe, PipeTransform } from '@angular/core';
import { DateTime, LocaleOptions } from 'luxon';

@Pipe({
	name: 'dateTimeToFormatHideMidnight'
})
export class DateTimeToFormatHideMidnightPipe implements PipeTransform {
	transform<T extends DateTime | null | undefined>(value: T, format: string, opts?: LocaleOptions) {
		var strVal = (value == null ? null : value.toFormat(format, opts)) as T extends DateTime ? string : null;
		if (strVal) {
			return strVal.replace("12:00 AM", "");
		} else {
			return strVal;
		}
	}
}
